import tw, { styled } from 'twin.macro';

const BreadcrumbPaper = styled.div`
    ${tw`px-6 py-4`}
    background: rgba(0,0,0, 0.2);
`;

export default BreadcrumbPaper;
